import type React from 'react';
import { useEvoFeedbackCollectorUrl } from '@/hooks/useEvoFeedbackCollectorUrl';
import type { EvoFeatureFeedbackCollectorProps } from '@/types/feedbackCollector';

/**
 * Evo version of the feedback collector component that wraps the oc-component.
 * This version includes theme support and additional Evo-specific parameters.
 *
 * This component automatically sources:
 * - product, baseUrl, and accountToken from configuration
 * - theme from the current theme context
 *
 * The `feature` prop is required, other props are optional with sensible defaults.
 *
 * @example
 * ```tsx
 * <EvoFeatureFeedbackCollector feature="Feature Settings" />
 * ```
 */
export const EvoFeatureFeedbackCollector: React.FC<EvoFeatureFeedbackCollectorProps> = ({
  feature,
  className,
  customerName,
  userId,
  roleId,
  language,
}) => {
  const url = useEvoFeedbackCollectorUrl({
    feature,
    customerName,
    userId,
    roleId,
    language,
  });

  if (!url) {
    return null;
  }

  return <oc-component href={url} className={className} />;
};

export default EvoFeatureFeedbackCollector;
